module.exports = __webpack_public_path__ + "static/media/8en.c07bb499.jpg";